import { observable } from "mobx";
import EnforcementUserType from "./enforcementUserType";
import type { EntityValidationRules } from "services/validationService";

// This entity has been generated, do not change its content, your changes might get lost. You CAN modify the rest of the file.
export default class EnforcementTabletUserCreateRequest {
  /**
   * User personal code.
   */
  @observable
  code!: string;

  /**
   * User pin.
   */
  @observable
  pin!: string;

  @observable
  userType!: EnforcementUserType;

  /**
   * Indicates if user is manager.
   */
  @observable
  isManager!: boolean;
}

export const EnforcementUserCreateValidationRules: EntityValidationRules<EnforcementTabletUserCreateRequest> = {
  code: {
    required: true,
    isLength: {
      min: 0,
      max: 25,
    },
  },
  userType: {
    required: true,
  },
  pin: {
    required: true,
    isLength: {
      min: 4,
      max: 10,
    },
  },
};
